import { render, staticRenderFns } from "./RightSta.vue?vue&type=template&id=c4003dc4&scoped=true&"
import script from "./RightSta.vue?vue&type=script&lang=js&"
export * from "./RightSta.vue?vue&type=script&lang=js&"
import style0 from "./RightSta.vue?vue&type=style&index=0&id=c4003dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4003dc4",
  null
  
)

export default component.exports